module.exports = __webpack_public_path__ + "img/11brice.430287dc.jpg";